import { Channel, invoke } from '@tauri-apps/api/core';

export interface TauriDownloadFile {
  /** Resource key = origin-relative path, e.g. "/clouds/c1/octree.bin". */
  key: string;
  /** Full https URL to fetch (Rust authenticates via the shared cookie jar). */
  url: string;
}

/**
 * Download a project's files into the offline cache via the Rust `download_files`
 * command — streaming to disk with live, cumulative byte progress (so the bar
 * moves even during a single large file) and authenticated CloudFront access.
 * Rejects with a human-readable message if anything fails.
 */
export async function tauriDownloadFiles(
  files: TauriDownloadFile[],
  onBytes: (bytesDone: number) => void,
): Promise<void> {
  const channel = new Channel<number>();
  channel.onmessage = (bytes) => onBytes(bytes);
  await invoke('download_files', { files, onProgress: channel });
}
